// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  flex-direction: column;
}

.second-level-menu {
  background: #fff;
  height: 100%;
  max-height: 92vh;
  width: calc(100% - 30px) !important;
  margin: 10px auto;
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
}

.homework_wrapper table td.list-ellipsis {
  max-width: 250px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.homework_wrapper table td {
  overflow: hidden;
}

.homework_wrapper table {
  font-size: 14px;
  /* table-layout: fixed; */
}

.homework_wrapper .button .fa {
  font-size: 15px !important;
}

.homework_wrapper .button {
  border-radius: 30px;
  width: 31px;
  height: 31px;
  border: none;
  /* margin-right: 10px; */
}

.topicListView .button:hover {
  background-color: #3e55a1;
  color: #ffffff !important;
}

.topicListView .button .fa:hover {
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/components/study-room/study-room.component.scss"],"names":[],"mappings":"AACA;EACI,sBAAA;AAAJ;;AAEA;EACI,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,mCAAA;EACA,iBAAA;EACA,uCAAA;EACA,wCAAA;AACJ;;AACA;EACE,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,eAAA;EACA,yBAAA;AAEF;;AACA;EACE,0BAAA;AAEF;;AACA;EACE,mBAAA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,wBAAA;AAEJ;;AACA;EACE,yBAAA;EACA,yBAAA;AAEF;;AAEA;EACE,WAAA;AACF","sourcesContent":["\n:host{\n    flex-direction: column;\n}\n.second-level-menu{\n    background: #fff;\n    height: 100%;\n    max-height: 92vh;\n    width: calc(100% - 30px) !important;\n    margin: 10px auto;\n    border-top-left-radius: 10px !important;\n    border-top-right-radius: 10px !important;\n}\n.homework_wrapper table td.list-ellipsis{\n  max-width: 250px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.homework_wrapper table td{\n  overflow: hidden;\n}\n\n.homework_wrapper table{\n  font-size: 14px;\n  /* table-layout: fixed; */\n}\n\n.homework_wrapper .button .fa{\n  font-size: 15px !important;\n}\n\n.homework_wrapper .button{\n  border-radius: 30px;\n    width: 31px;\n    height: 31px;\n    border: none;\n    /* margin-right: 10px; */\n}\n\n.topicListView .button:hover{\n  background-color: #3e55a1;\n  color: #ffffff !important;\n\n}\n\n.topicListView .button .fa:hover{\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
